import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { PatientDetailComponent } from '../detail/patient-detail.component';
import { DeleteDialog } from '../../dialogs/delete.component';
import { PatientService } from '../patient.service';
import { debounceTime, distinctUntilChanged, filter, finalize, Subject, switchMap, takeUntil } from 'rxjs';
import { BaseRespone, PaginationResult } from 'src/app/models/common.response';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { bloodGroup, MaritalStatus } from 'src/app/common/types/common';
import { MY_FORMATS } from 'src/app/common/dateFormat';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatSelectChange } from '@angular/material/select';
import { environment } from 'src/environments/environment';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { LoaderComponent } from "src/app/shared/loader/loader.component";
import { SearchCompareLabel, SearchCompareOption } from 'src/app/common/enums/search-compare-option';
import { IPatientInfo } from '../ipatient-info';
import { PatientViewComponent } from '../patient-view/patient-view.component';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { AgePipe } from 'src/app/pipe/age-calculate.pipe';
import { LoginService } from 'src/app/login.service';
import { DoctorDropdownComponent } from '../../dialogs/doctor-dropdown/doctor-dropdown.component';
import { OPDService } from '../../opd/opd.service';
import { IpatientToOPD } from '../../opd/opddetails/iopddetails';
import { Router } from '@angular/router';
import { SelectionService } from 'src/app/services/selection.service';
import { LookupService } from 'src/app/services/lookup.service';
import { CommonDropDown } from 'src/app/common/types/dropdown.type';
import { PAGE_SIZE_OPTIONS } from 'src/app/common/constant/constants.type';
import { DefaultValuePipe } from 'src/app/pipe/default-value.pipe';


@Component({
  selector: 'app-patient',
  standalone: true,
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TablerIconsModule,
    MatNativeDateModule,
    DatePipe,
    CommonModule,
    FallbackImageDirective,
    TranslateModule,
    LoaderComponent,
    AgePipe,
    DefaultValuePipe
  ],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  templateUrl: './patient.component.html',
  styleUrl: './patient.component.scss'
})
export class PatientComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  dataSource = new MatTableDataSource<IPatientInfo>([]);
  patientcount = 0;
  pagination!: PaginationResult;

  patientsdata: IPatientInfo[] = [];
  isLoading = false;

  searchpatient = new FormControl('');
  searchForm: FormGroup;

  staticimagepath = environment.imagePath;
  pageSizeOptions = PAGE_SIZE_OPTIONS;

  bloodgroupdetails = bloodGroup;
  MaritalStatuslist = MaritalStatus;

  serachCompareOptionlable = SearchCompareLabel;
  serachCompareList = Object.values(SearchCompareOption).filter(value => typeof value === 'number');
  selectedCompareOption: SearchCompareOption = SearchCompareOption.Equal;

  minDate = new Date(1800, 0, 1);
  maxDate = new Date();
  doctorslist: CommonDropDown[] = [];
  doctorsAvailableForToday: CommonDropDown[] = [];
  private destroy$ = new Subject<void>();

  ListOfName: string[] = ['FirstName', 'MiddleName', 'LastName'];
  selectedColumnName = '';
  isFilterActive = false;
  selectedFilterName = '';
  selectedFilterEducation = '';
  selectedFilterFamilyDr = '';
  compareOptionsPerField: { [key: string]: SearchCompareOption } = {
    Name: SearchCompareOption.Equal,
    Education: SearchCompareOption.Equal,
    FamilyDr: SearchCompareOption.Equal,
    Age: SearchCompareOption.Equal,
    BloodGroup: SearchCompareOption.Equal,
    MaritalStatus: SearchCompareOption.Equal,
  };

  private _unsubscribeAll = new Subject<void>();

  displayedColumns: string[] = [
    'patientno', 'name', 'mobile', 'Date of Birth', 'age',
    'familyDR', 'bloodGroup', 'action'
  ];//'education', 'maritalStatus'
  suspendFormSearch = false;
  searchInputChangedManually = false;

  constructor(
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private _patientService: PatientService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private translationUtils: TranslationUtils,
    private loginservice: LoginService,
    private opdService: OPDService,
    private router: Router,
    private selectionService: SelectionService,
    private _lookupService: LookupService
  ) {
    this.searchForm = this.fb.group({
      Education: [''],
      Age: [''],
      FamilyDr: [''],
      FirstName: [''],
      MiddleName: [''],
      LastName: [''],
      BloodGroup: [''],
      MaritalStatus: [''],
      BirthDate: ['']
    });
  }

  ngOnInit(): void {
    this.loaderService.show();

    this._patientService.pagination$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((pagination) => {
        if (pagination) {
          this.pagination = pagination;
          this.patientcount = pagination.rowCount;
        }
      });

    this._patientService.patients$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data) => {
        this.patientsdata = data;
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
      });

    // Load doctors available for current date
    this._lookupService.getDoctors(new Date())
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (data: CommonDropDown[]) => {
          this.doctorsAvailableForToday = this.doctorslist = data;
        },
        error: () => {
          this.doctorsAvailableForToday = this.doctorslist = [];
        }
      });

    setTimeout(() => {
      this.loaderService.hide();
    }, 500)

    this.initFormSearch();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }


  private initFormSearch(): void {
    this.searchForm.valueChanges.pipe(
      takeUntil(this._unsubscribeAll),
      debounceTime(1000),
      filter(() => !this.suspendFormSearch),
      filter(() => this.searchInputChangedManually),
      distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
      switchMap(formValue => {
        const queries = this.buildSearchQueries(formValue);

        this.loaderService.show();

        return this._patientService.getPatients({
          pageNumber: 0,
          pageSize: this.pagination?.pageSize ?? 100,
          isDescending: false,
          searchValue: '',
          queries
        }).pipe(finalize(() => setTimeout(() => this.loaderService.hide())));
      })
    ).subscribe(response => {
      this.updateTableData(response);
    });
  }



  private buildSearchQueries(formValue: any): any[] {
    const queries: any[] = [];

    if (this.selectedColumnName && formValue[this.selectedColumnName]?.trim()) {
      queries.push({
        searchProperty: this.selectedColumnName,
        searchValue: formValue[this.selectedColumnName],
        searchCompareOption: this.compareOptionsPerField['Name']  // assuming Name is the selectedColumnName
      });
    }
    ['Age', 'Education', 'BloodGroup', 'MaritalStatus', 'FamilyDr'].forEach(field => {
      if (formValue[field]?.toString().trim()) {
        queries.push({
          searchProperty: field,
          searchValue: formValue[field],
          searchCompareOption: this.compareOptionsPerField[field]
        });
      }
    });

    return queries;
  }

  private updateTableData(response: BaseRespone<any>): void {
    if (response?.result) {
      this.dataSource.data = response.result.patients;
      this.patientcount = response.result.pagination.rowCount;
      this.pagination = response.result.pagination;
    }
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openDialog(): void {
    this.dialog.open(PatientDetailComponent, {
      autoFocus: false,
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        isDoctorAvailable: this.hasDoctors
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.pagination.currentPage = 0;
        this.loadPatients();
      }
    });
  }

  deleteOpenDialog(id: number): void {
    this.dialog.open(DeleteDialog, {
      width: 'auto',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '300ms',
      disableClose: true,
      data: { message: `${this.translate.instant('DELETE_DIALOG')} ${this.translate.instant('ENTITY.PATIENT')} ?` }
    }).afterClosed().subscribe(result => {
      if (result === "confirm") {
        this._patientService.deletePatient(id).subscribe(response => {
          if (response.isSuccess) {
            this.loadPatients();
            this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.DELETE', this.translate.instant('ENTITY.PATIENT')));
          } else {
            this.toastr.error(Object.values(response.errors).flat().join("\n"));
          }
        });
      }
    });
  }

  editOpenDialog(data: IPatientInfo): void {
    this.dialog.open(PatientDetailComponent, {
      autoFocus: false,
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        patient: data
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.loadPatients();
      }
    });
  }

  loadPatients(): void {
    const formValue = this.searchForm.value;
    const hasActiveFilters = Object.values(formValue).some(val => val?.toString().trim());

    if (hasActiveFilters) {
      this.applySearchFilters();
      return;
    }


    this.loaderService.show();
    this._patientService.getPatients({
      pageSize: this.pagination?.pageSize ?? 100,
      currentPage: this.pagination?.currentPage ?? 0
    }).pipe(finalize(() => this.loaderService.hide()))
      .subscribe(response => this.updateTableData(response));
  }

  onBloodGroupChange(bloodGroup: MatSelectChange): void {
    this.searchInputChangedManually = true;
    this.searchForm.get('BloodGroup')?.setValue(bloodGroup.value);
  }

  onSerachChange(event: MatSelectChange, filterType: string): void {
    this.searchInputChangedManually = true;
    const selectedValue = event.value;
    this.compareOptionsPerField[filterType] = selectedValue;
    switch (filterType) {
      case 'Name': this.selectedFilterName = selectedValue; break;
      case 'Education': this.selectedFilterEducation = selectedValue; break;
      case 'FamilyDr': this.selectedFilterFamilyDr = selectedValue; break;
    }
  }

  onMaritalStatusChange(event: MatSelectChange): void {
    this.searchInputChangedManually = true;
    this.searchForm.get('MaritalStatus')?.setValue(event.value);
  }

  clearBirthDate(event: Event): void {
    event.stopPropagation();
    this.searchForm.get('BirthDate')?.setValue(null);
  }

  onColumnChange(event: MatSelectChange): void {
    const newColumn = event.value;

    this.suspendFormSearch = true;
    this.ListOfName.forEach(name => {
      if (name !== newColumn && this.searchForm.contains(name)) {
        this.searchForm.removeControl(name);
      }
    });

    if (!this.searchForm.contains(newColumn)) {
      this.searchForm.addControl(newColumn, this.fb.control(''));
    }

    this.searchForm.get(newColumn)?.setValue('', { emitEvent: false });
    this.searchInputChangedManually = false;

    setTimeout(() => {
      this.selectedColumnName = newColumn;
      this.isFilterActive = true;
      this.suspendFormSearch = false;
      this.cdr.detectChanges();
    }, 100); // Allow form structure to stabilize
  }


  isFilterApplied(): boolean {
    const control = this.searchForm.get(this.selectedColumnName);
    return !!(this.selectedColumnName && control?.value?.trim());
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  applySearchFilters(): void {

    const formValue = this.searchForm.value;
    const queries = this.buildSearchQueries(formValue);

    this.loaderService.show();
    this._patientService.getPatients({
      pageNumber: 0,
      pageSize: this.pagination?.pageSize ?? 100,
      isDescending: false,
      queries
    }).pipe(finalize(() => (setTimeout(() => {
      this.loaderService.hide();
    }, 500))))
      .subscribe(response => this.updateTableData(response));
  }

  onSearchInputChanged(): void {
    this.searchInputChangedManually = true;
  }

  viewPatientDetails(element: IPatientInfo): void {
    this.dialog.open(PatientViewComponent, {
      autoFocus: false,
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      data: {
        patient: element,
      }
    }).afterClosed().subscribe();
  }

  get hasDoctors(): boolean {
    return this.doctorsAvailableForToday.length > 0;
  }

  createOPD(element: IPatientInfo): void {
    const patientId = element.id;
    if (this.loginservice.isDoctor()) {
      const doctorId = Number(this.loginservice.getUserId());
      this.createOPDRequest(patientId, doctorId);
      return;
    }

    if (this.doctorsAvailableForToday.length === 1) {
      const doctorId = Number(this.doctorsAvailableForToday[0].id);
      this.createOPDRequest(patientId, doctorId);
      return;
    }

    const dialogRef = this.dialog.open(DoctorDropdownComponent, {
      width: '290px',
      data: { Date: new Date() }
    });

    dialogRef.afterClosed().subscribe((doctorId?: number) => {
      if (doctorId) {
        this.createOPDRequest(patientId, doctorId);
      }
    });
  }

  private createOPDRequest(patientId: number, doctorId: number): void {
    const payload: IpatientToOPD = { doctorId, patientId };

    // Store doctor and current date in selection service so appointment page can restore it
    const currentDate = new Date();
    this.selectionService.set({
      doctorId: doctorId.toString(),
      appointmentDate: currentDate.toISOString()
    });
    this.opdService.createPatientToOPD(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.OPD')));
          this.router.navigate(['/opd', patientId, 'consultation', response.result.id]);
        }
      },
      error: (err) => {
        if (err.error?.message) {
          this.toastr.error(err.error.message);
        } else {
          const allErrors = Object.values(err.error.errors || {}).flat();
          this.toastr.error(allErrors.join('\n'));
        }
      }
    });
  }

  printLabel(patient: IPatientInfo): void {
    const staticAvatarPath = `${window.location.origin}/assets/images/profile/user-1.jpg`;
    const profileImagePath = patient?.profileImagePath
      ? `${this.staticimagepath}${patient.profileImagePath}`
      : staticAvatarPath;

    const fullName = `${patient?.salute || ''} ${patient?.firstName || ''} ${patient?.middleName || ''} ${patient?.lastName || ''}`.trim();
    const address = patient?.address?.[0]?.address1 || '';
    const contact = patient?.contactInfo?.[0]?.contact || '';
    const age = patient?.age || '';

    const printContents = `
    <div style="border: 1px solid #000; padding: 5px; width: 400px; margin:5px;">
      <div style="display: flex; align-items: center; gap: 16px;">
        <div style="display: flex; justify-content: center; align-items: center;">
          <img style="width: 70px; height: 70px; border-radius: 50%;" src="${profileImagePath}" onerror="this.onerror=null; this.src='${staticAvatarPath}';" alt="User Logo" />
        </div>
        <div>
          <p style="margin: 4px 0;">Name: ${fullName}</p>
          ${address ? `<p style="margin: 4px 0;">Address: ${address}</p>` : ''}
          ${contact ? `<p style="margin: 4px 0;">Contact: ${contact}</p>` : ''}
          ${age ? `<p style="margin: 4px 0;">Age: ${age}</p>` : ''}
        </div>
      </div>
    </div>
  `;

    const popupWin = window.open('', '_blank', 'width=600,height=600');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
      <html>
        <head>
          <title>Patient Label</title>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>
    `);
      popupWin.document.close();
    }
  }

}